import React, { Component } from "react";

export default class Content extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <div className="content_s" id="scrollBox">
            <div className="newHeadTitle healthHeadTitle">{this.props.data.name}</div>
            <div className="textTime">{this.props.data.time}</div>
            <div className="newPreamble">
                <div className="title page_title">{this.props.data.preamble.title}</div>
            </div>
            <div className="content newContent healthContent">
                {this.props.data.preamble.wordlist.map((word, i) => <div key={i}>{word}</div>)}
            </div>
            {this.props.data.mainWords.map((word, i) => <div key={i+'_list'}>
                <div className="healthTopic">{word.title}</div>
                <div className="content newContent healthContent">{word.wordlist.map((wd, j) => <div key={j+'__j_'}>{wd}</div>)}</div>
            </div>)}
            <div className="signature">{this.props.data.company}</div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/component/healthChina/Content.js